import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/range';

export class PagerService {
    getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
        // calculate total pages
        let totalPages = Math.ceil(totalItems / pageSize);
        let startPage: number, endPage: number = 10;
        if (totalPages <= 10 || currentPage <= 6) {
            // less than 10 total pages so show all
            startPage = 1;
        } else {
            // more than 10 total pages so calculate start page
             if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
            } else {
                startPage = currentPage - 5;
            }
        }

        // calculate start and end item indexes
        let startIndex = (currentPage - 1) * pageSize;
        let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        let pages = Array.from(new Array(((totalPages >= 10) ? endPage : totalPages)), (x,i) => i + startPage);
        //let pages = Array.from(new Array(endPage), (x,i) => i + startPage)

        // create an array of pages to ng-repeat in the pager control
        // let pages = Array.range(startPage, endPage + 1);
        
        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }
}